/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const More: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M12 22.667C17.891 22.667 22.667 17.891 22.667 12C22.667 6.109 17.891 1.333 12 1.333C6.109 1.333 1.333 6.109 1.333 12C1.333 17.891 6.109 22.667 12 22.667V22.667ZM24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12Z" />

      <path d="M12.1132 13.125C11.4912 13.125 10.9872 12.621 10.9872 11.999C10.9872 11.377 11.4912 10.873 12.1132 10.873C12.7352 10.873 13.2392 11.377 13.2392 11.999C13.2392 12.621 12.7352 13.125 12.1132 13.125ZM7.45022 13.125C6.82822 13.125 6.32422 12.621 6.32422 11.999C6.32422 11.377 6.82822 10.873 7.45022 10.873C8.07222 10.873 8.57622 11.377 8.57622 11.999C8.57622 12.621 8.07222 13.125 7.45022 13.125V13.125ZM16.7772 13.125C16.1552 13.125 15.6512 12.621 15.6512 11.999C15.6512 11.377 16.1552 10.873 16.7772 10.873C17.3992 10.873 17.9032 11.377 17.9032 11.999C17.9032 12.621 17.3992 13.125 16.7772 13.125Z" />

    </StyledIconBase>
  )
})

More.displayName = 'More'

export const MoreDimensions = {height: 24, width: 24}
